import FileSaver from "file-saver";
import { map } from "rxjs";
import { IAttachmentObject } from "../../components/Manuals/ManualsList/module/constants";
import { RESPONSE_TYPE } from "../../module/constants";
import { GET, POST, DELETE } from "../../module/services/fetch";

export const fetchRequestAttachments = (requestId: string) =>
  GET(`request/${requestId}/attachments`).pipe(
    map((response: any) => response)
  );

export const saveRequestAttachments = (
  requestId: string,
  formdata: FormData
) => {
  return POST(
    `request/${requestId}/attachments`,
    formdata,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
};

export const downloadAttachments = (attachment: IAttachmentObject) =>
  GET(
    `attachments/${attachment.id}`,
    undefined,
    undefined,
    RESPONSE_TYPE.BASE_64
  )
    .pipe(
      map((response) => {
        return response.text();
      })
    )
    .subscribe(
      (res) => {
        res.then((base64: any) => {
          const blob = convertBase64ToBlob(base64);
          FileSaver.saveAs(blob, attachment.name);
        });
      },
      (error) => {
        console.log(error);
      }
    );

export const deleteAttachments = (attachmentsId: string) =>
  DELETE(`attachments/${attachmentsId}`).pipe(map((response: any) => response));

export const convertBase64ToBlob = (base64String: any, sliceSize = 512) => {
  // let arr = base64String.split(",");
  let byteCharacters = atob(base64String);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays);
};
